import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';

@Injectable({
  providedIn: 'root',
})
export class VmsService {
  url: string;
  excelContent: any;

  constructor(private apiService: ApiService) {}

  getMyCompanyDetails(parkTenantId: string): Observable<any> {
    return this.apiService
      .get(`${APIs.getMyCompanyDetails}?parkTenantId=${parkTenantId}`)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getHostDetail(data): Observable<any> {
    return this.apiService.get(APIs.getVmsHostDetail, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getVehicleType(): Observable<any> {
    return this.apiService.get(APIs.getVmsVehicleType).pipe(
      map((response) => {
        return response.list;
      })
    );
  }

createInvitation(data):Observable<any>{
  return this.apiService.post(APIs.createVmsInvitation,data).pipe(
    map((response) => {
      return response;
    })
  );
}

getMeetingPurpose():Observable<any>{
  return this.apiService.get(APIs.getVmsMeetingPurpose).pipe(
    map((response) => {
      return response.list;
    })
  );
}

getInvitationDetail(data){
  return this.apiService.get(APIs.getInvitationDetail,data).pipe(
    map((response) => {
      return response.data;
    })
  );
}

resendInvitation(data){
  return this.apiService.put(APIs.resendInvitation+`?InvitationID=${data}`).pipe(
    map((response) => {
      return response;
    })
  );
}

cancelInvitation(data){
  return this.apiService.put(APIs.cancelInvitation+`?InvitationID=${data}`).pipe(
    map((response) => {
      return response;
    })
  );
}

deleteGuest(data){
  return this.apiService.put(APIs.deleteVmsGuest,data).pipe(
    map((response) => {
      return response;
    })
  );
}

approvalRemainder(data){
  return this.apiService.get(APIs.approvalRemainder,data).pipe(
    map((response) => {
      return response;
    })
  );
}

getInvitationList(data){
  return this.apiService.get(APIs.getVmsInvitationList,data).pipe(
    map((response) => {
      return response.list;
    })
  );
}

getTemplate(){
  return this.apiService.get(APIs.getBulkInviteTemplate).pipe(
    map((response) => {
      return response;
    })
  );
}

setExcelData(data){
  this.excelContent=data;
  console.log(this.excelContent)
}

getExcelData(){
  console.log(this.excelContent)

  return this.excelContent
}
getCompanyList(data): Observable<any> {
  return this.apiService.post(APIs.getInviteCompanyList,data).pipe(
    map((response) => {
      return response?.list;
    })
  );
}

getHistoryDetail(data): Observable<any> {
  return this.apiService.post(APIs.getHistoryDetails,data).pipe(
    map((response) => {
      return response;
    })
  );
}
}
